import React, { useCallback } from 'react';
import { getTranslations } from '@translations';
import { useHeaderContext } from '@context';
import PropTypes from 'prop-types';

const MenuSeeAll = ({ label, url, level, onClick, className }) => {
  const { platformBaseUrl } = useHeaderContext();
  const translations = getTranslations();

  const handleClick = useCallback(
    e => {
      onClick(e, { level, type: 'see-all', destination: url });
    },
    [onClick, url, level],
  );

  /* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions */
  return (
    <li className={className}>
      <a href={`${platformBaseUrl}${url}`} onClick={handleClick}>
        {translations('header.menu.items.see.all')} &laquo; {label} &raquo;
      </a>
    </li>
  );
};

MenuSeeAll.propTypes = {
  level: PropTypes.number.isRequired,
  label: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string,
};

MenuSeeAll.defaultProps = {
  className: undefined,
};

MenuSeeAll.displayName = 'MenuSeeAll';

export default MenuSeeAll;
